/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgot_SentInputs */

const cs_auth_forgot_sent = /** @type {(inputs: Auth_Forgot_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokud účet s touto adresou existuje, poslali jsme odkaz pro nastavení nového hesla.`)
};

const en_auth_forgot_sent = /** @type {(inputs: Auth_Forgot_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If an account exists for this address, we have sent a link to reset the password.`)
};

/**
* | output |
* | --- |
* | "If an account exists for this address, we have sent a link to reset the password." |
*
* @param {Auth_Forgot_SentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_forgot_sent = /** @type {((inputs?: Auth_Forgot_SentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgot_SentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_forgot_sent(inputs)
	return cs_auth_forgot_sent(inputs)
});